enum BillingType {
    Direct = "DIRECT",
    Indirect = "INDIRECT",
    Stores = "STORES",
}

/** Paramètres pour affecter un utilisateur B2B à une licence d'organisation via l'API REST. */
type AssignB2BUserLicenseParams = {
    userId: string;
    userMail: string;
};

/** Paramètres pour désaffecter un utilisateur B2B d'une licence d'organisation via l'API REST. */
type RemoveB2BUserLicenseParams = {
    userId: string;
    userMail: string;
    orgLicenseId: string;
};

export type { AssignB2BUserLicenseParams, RemoveB2BUserLicenseParams };

export { BillingType };
